export default __webpack_public_path__ + "static/media/Times.7cfc6be5.svg";